// Social / review destinations for the QR "Follow Us" landing page (/follow).
export const SOCIAL = {
  facebook: 'https://www.facebook.com/p/Gemiya-61585996169955/',
  instagram: 'https://www.instagram.com/gemiy_aaa',
  tiktok: 'https://www.tiktok.com/@gemiya.legemiya',
  googleReview: 'https://search.google.com/local/writereview?placeid=ChIJoxurmnZv5kcRgb1HI80sXtU',
};
